<script setup lang="ts">
const props = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
});

const { toLocaleUrl } = useLocaleUrl();

const ctaHref = computed(() => toLocaleUrl(props.blok.ctaLink?.cached_url));
</script>

<template>
    <section :id="blok.id ? blok.id : null" class="bg-white dark:bg-midnight-blue">
        <div
            class="items-center py-8 px-4 mx-auto max-w-screen-xl lg:grid xl:grid-cols-3 lg:gap-8 xl:gap-24 sm:py-16 lg:px-6"
        >
            <div class="mb-8 lg:mb-0">
                <h2
                    class="font-serif mb-4 text-4xl tracking-tight font-light text-gray-900 dark:text-white"
                >
                    {{ blok.title }}
                </h2>
                <p class="mb-4 text-gray-500 sm:text-xl dark:text-gray-400">
                    {{ blok.description }}
                </p>
                <p class="mb-4 text-gray-500 sm:text-xl dark:text-gray-400"></p>
                <a
                    v-if="blok.ctaText && blok.ctaLink"
                    :href="ctaHref"
                    :target="blok.ctaLink.target"
                    class="inline-flex items-center text-lg font-medium text-primary-600 hover:text-primary-800 dark:text-primary-500 dark:hover:text-primary-700"
                >
                    {{ blok.ctaText }}
                    <svg
                        class="ml-1 w-6 h-6"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                </a>
            </div>
            <div class="text-center md:text-left col-span-2 space-y-8 md:grid md:grid-cols-2 md:gap-12 md:space-y-0">
                <StoryblokComponent v-for="item in blok.gridItems" :key="item._uid" :blok="item" />
            </div>
        </div>
    </section>
</template>
